import { render, staticRenderFns } from "./bankAccountInfo.vue?vue&type=template&id=6066f815&scoped=true"
import script from "./bankAccountInfo.vue?vue&type=script&lang=js"
export * from "./bankAccountInfo.vue?vue&type=script&lang=js"
import style0 from "./bankAccountInfo.vue?vue&type=style&index=0&id=6066f815&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6066f815",
  null
  
)

export default component.exports